export default {"src":"/_next/static/media/StarIconNew.65996a33.svg","height":15,"width":15};